"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Select = _interopRequireDefault(require("../../../Select"));
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledSelected = _Select["default"].StyledSelected;
var SEGMENTS_PLACEHOLDER = 'Выбрать сегмент';
var CallReasons = function CallReasons(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    forwardedRef = _ref.forwardedRef,
    groups = _ref.groups,
    reasons = _ref.reasons,
    segments = _ref.segments,
    _ref$requireNoteIds = _ref.requireNoteIds,
    requireNoteIds = _ref$requireNoteIds === void 0 ? [] : _ref$requireNoteIds,
    _ref$selectedGroupId = _ref.selectedGroupId,
    selectedGroupId = _ref$selectedGroupId === void 0 ? null : _ref$selectedGroupId,
    _ref$selectedReasonId = _ref.selectedReasonIds,
    selectedReasonIds = _ref$selectedReasonId === void 0 ? null : _ref$selectedReasonId,
    _ref$selectedSegmentI = _ref.selectedSegmentId,
    selectedSegmentId = _ref$selectedSegmentI === void 0 ? null : _ref$selectedSegmentI,
    description = _ref.description,
    onClickOutside = _ref.onClickOutside,
    onSubmit = _ref.onSubmit;
  var firstReason = (0, _find2["default"])(reasons, {
    value: selectedReasonIds === null || selectedReasonIds === void 0 ? void 0 : selectedReasonIds[0]
  }) || reasons[0];
  var _useState = (0, _react.useState)(selectedGroupId || firstReason.groupId),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    groupState = _useState2[0],
    setGroupState = _useState2[1];
  var _useState3 = (0, _react.useState)(selectedReasonIds),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    reasonsState = _useState4[0],
    setReasonsState = _useState4[1];
  var _useState5 = (0, _react.useState)(selectedSegmentId),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    segmentState = _useState6[0],
    setSegmentState = _useState6[1];
  var _useState7 = (0, _react.useState)(description),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    descriptionState = _useState8[0],
    setDescriptionState = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    isClosed = _useState10[0],
    setIsClosed = _useState10[1];
  var handleClose = function handleClose() {
    if (isClosed) {
      return;
    }
    setIsClosed(true);
    onClickOutside();
  };
  var handleBlur = function handleBlur(_ref2) {
    var currentTarget = _ref2.currentTarget,
      relatedTarget = _ref2.relatedTarget;
    if (!relatedTarget) {
      return;
    }
    if (!currentTarget.contains(relatedTarget)) {
      handleClose();
    }
  };
  var handleGroupChange = function handleGroupChange(_ref3) {
    var detail = _ref3.detail;
    setGroupState(detail.value);
  };
  var handleReasonChange = function handleReasonChange(_ref4) {
    var target = _ref4.target;
    var dataset = target.dataset,
      checked = target.checked;
    var value = dataset.value;
    var newReasons = checked ? (0, _concat2["default"])(reasonsState, value) : (0, _difference2["default"])(reasonsState, [value]);
    setReasonsState((0, _uniq2["default"])(newReasons));
  };
  var handleSegmentChange = function handleSegmentChange(_ref5) {
    var detail = _ref5.detail;
    setSegmentState(detail.value);
  };
  var handleDescriptionChange = function handleDescriptionChange(_ref6) {
    var target = _ref6.target;
    setDescriptionState(target.value);
  };
  var handleSubmit = function handleSubmit() {
    var needDescription = !(0, _isEmpty2["default"])((0, _intersection2["default"])(requireNoteIds, reasonsState));
    var formData = {
      reasons: reasonsState || [],
      isUpdating: !(0, _isEmpty2["default"])(selectedReasonIds),
      segment: segmentState ? segmentState : undefined,
      description: needDescription ? descriptionState : undefined
    };
    onSubmit(formData);
  };
  var segmentsRenderer = function segmentsRenderer() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSelect, {
      className: "segments",
      value: segmentState,
      options: segments,
      placeholder: SEGMENTS_PLACEHOLDER,
      onChange: handleSegmentChange
    }), /*#__PURE__*/_react["default"].createElement(StyledSplit, null));
  };
  var reasonsRenderer = function reasonsRenderer() {
    return reasons.map(function (_ref7) {
      var title = _ref7.title,
        value = _ref7.value,
        groupId = _ref7.groupId;
      return groupId === groupState && /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
        key: value,
        className: "reasons",
        "data-value": value,
        checked: reasonsState === null || reasonsState === void 0 ? void 0 : reasonsState.includes(value),
        onChange: handleReasonChange
      }, title);
    });
  };
  var segmentFilled = (0, _isEmpty2["default"])(segments) || !(0, _isEmpty2["default"])(segments) && segmentState;
  var needDescription = !(0, _isEmpty2["default"])((0, _intersection2["default"])(requireNoteIds, reasonsState));
  var descriptionFilled = !needDescription || needDescription && !!descriptionState;
  var isFilled = segmentFilled && !(0, _isEmpty2["default"])(reasonsState) && descriptionFilled;
  return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
    onBlur: handleBlur,
    onClickOutside: handleClose
  }, /*#__PURE__*/_react["default"].createElement(StyledCallReasons, {
    ref: forwardedRef,
    className: className
  }, segments && segmentsRenderer(), /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(StyledSelect, {
    options: groups,
    value: groupState,
    onChange: handleGroupChange
  }), /*#__PURE__*/_react["default"].createElement(StyledReasonList, null, reasonsRenderer()), needDescription && /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    value: descriptionState,
    placeholder: "\u0423\u0442\u043E\u0447\u043D\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443",
    onChange: handleDescriptionChange
  }), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    disabled: !isFilled,
    onClick: handleSubmit
  }, "\u0413\u043E\u0442\u043E\u0432\u043E")));
};
var StyledCallReasons = _styledComponents["default"].form.withConfig({
  displayName: "CallReasons__StyledCallReasons",
  componentId: "sc-qdinv7-0"
})(["font-size:14px;"]);
var StyledTitle = _styledComponents["default"].b.withConfig({
  displayName: "CallReasons__StyledTitle",
  componentId: "sc-qdinv7-1"
})(["display:block;margin:0 10px 10px;width:calc(100% - 20px);"]);
var StyledSelect = (0, _styledComponents["default"])(_Select["default"]).withConfig({
  displayName: "CallReasons__StyledSelect",
  componentId: "sc-qdinv7-2"
})(["margin:0 10px 10px;height:41px;width:calc(100% - 20px);", "{border-radius:4px;border:solid 1px #17181a;}"], StyledSelected);
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "CallReasons__StyledCheckbox",
  componentId: "sc-qdinv7-3"
})(["margin-bottom:10px;&:last-child{margin-bottom:0;}"]);
var StyledSplit = _styledComponents["default"].hr.withConfig({
  displayName: "CallReasons__StyledSplit",
  componentId: "sc-qdinv7-4"
})(["border:none;background:#dedede;height:1px;width:100%;margin-bottom:5px;"]);
var StyledReasonList = _styledComponents["default"].div.withConfig({
  displayName: "CallReasons__StyledReasonList",
  componentId: "sc-qdinv7-5"
})(["margin-bottom:10px;max-height:150px;overflow-y:auto;padding:5px 10px;width:100%;"]);
var StyledDescription = _styledComponents["default"].textarea.withConfig({
  displayName: "CallReasons__StyledDescription",
  componentId: "sc-qdinv7-6"
})(["border-radius:4px;border:solid 1px #c2c5cc;box-sizing:border-box;font-size:14px;height:53px;margin:0 10px 10px;padding:6px 12px;resize:none;width:calc(100% - 20px);"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CallReasons__StyledButton",
  componentId: "sc-qdinv7-7"
})(["background-color:#007aff;border:none;color:white;font-size:13px;margin:0 10px;width:calc(100% - 20px);&:hover{color:white;}", ""], function (props) {
  return props.disabled && "\n    opacity: .3\n  ";
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(CallReasons, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});